import React from 'react'
import TopFooter from '../userFooter/TopFooter'
import MainFooter from '../userFooter/MainFooter'

const UserFooter = () => {
  return (
    <footer>
      <TopFooter />
      <MainFooter />
    </footer>
  )
}

export default UserFooter